export default function getMetadataFields(metadata) {
  if (metadata.fields) {
    return [...metadata.fields];
  }

  const groups = metadata.groups || metadata.tabs;

  return groups.map(getMetadataFields).flat();
}
